import { TAGS } from "../constants";
import {
  CreateOrder,
  Order,
  OrderWithPrescription,
  UpdateBulkOrdersArg,
} from "../types";
import { api } from "./api";

export const ordersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation<OrderWithPrescription, CreateOrder>({
      query: (body) => ({
        url: "/api/orders",
        method: "POST",
        body,
      }),
      //we cannot use it because we are fetching additional information on the back for getPatientOrders and we do not do it here
      // onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
      //   const { data } = await queryFulfilled;

      //   dispatch(
      //     ordersApi.util.updateQueryData(
      //       "getPatientOrders",
      //       data.patient_id,
      //       (draft) => {
      //         (draft || []).push(data);
      //       }
      //     )
      //   );
      // },
      invalidatesTags: (_returns, _error, args) => [
        { type: TAGS.ORDERS, id: args.patient_id },
      ],
    }),
    getPatientOrders: builder.query<
      { data: OrderWithPrescription[]; count: number },
      number
    >({
      query: (patientId) => ({
        url: `/api/orders/patient/${patientId}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.ORDERS, id: args },
      ],
    }),
    updateOrder: builder.mutation<Order, Partial<Order>>({
      query: ({ id, ...rest }) => ({
        method: "PUT",
        url: `/api/orders/${id}`,
        body: rest,
      }),
      invalidatesTags: [TAGS.ORDERS, TAGS.INVOICES],
    }),
    bulkUpdateOrders: builder.mutation<Order[], UpdateBulkOrdersArg>({
      query: (bulkUpdates) => ({
        method: "PUT",
        url: `/api/orders`,
        body: bulkUpdates,
      }),
      invalidatesTags: [TAGS.ORDERS, TAGS.INVOICES],
    }),
    payForOrder: builder.mutation<OrderWithPrescription, number>({
      query: (orderId) => ({
        url: `/api/orders/${orderId}/pay`,
        method: "POST",
      }),
      // onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
      //   const { data } = await queryFulfilled;

      //   dispatch(
      //     ordersApi.util.updateQueryData(
      //       "getPatientOrders",
      //       data.patient_id,
      //       (draft) => {
      //         draft.push(data);
      //       }
      //     )
      //   );
      // },
      invalidatesTags: [TAGS.ORDERS],
    }),
    generateEmpowerOrder: builder.mutation({
      query: (orderId) => ({
        method: "POST",
        url: `/api/empower/order/${orderId}`,
      }),
    }),
    getOrders: builder.query<
      { data: OrderWithPrescription[]; count: number },
      | {
          billing_model?: string;
          pharmacy?: string;
          product?: string;
          status?: string;
          patient_id?: string;
          is_delayed?: boolean;
          from: number;
          to: number;
          id?: string;
          product_id?: number;
        }
      | undefined
    >({
      query: (params) => ({
        url: `/api/orders`,
        method: "GET",
        params,
      }),
      providesTags: [TAGS.ORDERS],
    }),
    getOrder: builder.query<OrderWithPrescription, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/orders/${id}`,
      }),
    }),
    getOrderForInvoice: builder.query<OrderWithPrescription, string>({
      query: (invoiceId) => ({
        method: "GET",
        url: `/api/orders/invoice/${invoiceId}`,
      }),
    }),
  }),
});

export const {
  useUpdateOrderMutation,
  usePayForOrderMutation,
  useGetPatientOrdersQuery,
  useCreateOrderMutation,
  useGenerateEmpowerOrderMutation,
  useGetOrdersQuery,
  useBulkUpdateOrdersMutation,
  useGetOrderQuery,
  useGetOrderForInvoiceQuery,
} = ordersApi;
